/**
 * Version affichée de l'application, au format `AAAA-MM X.Y`.
 *
 * Tenue à la main plutôt que lue depuis package.json : la version npm sert au
 * packaging et ne bouge pas au rythme des mises en production, alors que ce
 * repère-ci n'existe que pour savoir, depuis l'interface, quelle livraison est
 * en ligne.
 */
export const APP_VERSION = "2026.10 - 3.0";
